<template>
    <v-dialog width="400px" v-model="dialog">

        <template v-slot:activator="{ on: {click} }" class="primary">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="disabled && on">
                        <v-btn
                            v-on:click="click"
                            :disabled="disabled"
                        >
                        <v-icon>mdi-file-document-outline</v-icon>&nbsp;Invoice
                        </v-btn>
                    </span>
                </template>
                <span>Restaurant not selected</span>
            </v-tooltip>
        </template>

        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">Request invoice</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-row align="stretch">
                    <!-- right panel -->
                    <v-col>
                        <v-form ref="form">
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        outlined
                                        label="Invoice number*"
                                        hint="A000125"
                                        required
                                        v-model="invoice_number"
                                        :error-messages="invoiceNumberErrors"
                                        @input="$v.invoice_number.$touch()"
                                        @blur="$v.invoice_number.$touch()"
                                        dense
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                            outlined
                                            label="Сommission £ / hour *"
                                            hint="Dream Drivers Сommission"
                                            required
                                            v-model="comission"
                                            :error-messages="invoiceComissionErrors"
                                            @input="$v.comission.$touch()"
                                            @blur="$v.comission.$touch()"
                                            dense
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <div class="d-flex justify-center">
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="preview"
                                ><v-icon left>mdi-eye</v-icon>Preview</v-btn>
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="submit"
                                ><v-icon left>mdi-upload</v-icon>Download</v-btn>
                                <v-btn
                                        class="mr-4 warning"
                                        :loading="localLoading"
                                        depressed
                                        @click="dialog=false"
                                ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                            </div>

                        </v-form>
                    </v-col>
                    <!--/ right panel -->
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    name: "RequestInvoiceRestaurantModal",
    props: ['periodDateFrom', 'periodDateTo', 'restaurantId', 'driverId', 'disabled'],
    validations: {
        invoice_number: { required },
        comission: { required },
    },
    data: () => ({
        /*valid: false,*/
        localLoading: false,
        dialog: false,
        // -- form fields
        invoice_number: void 0,
        comission: 1.5,
    }),
    computed: {
        invoiceNumberErrors () {
            const errors = [];
            if (!this.$v.invoice_number.$dirty) {
                return errors;
            }
            !this.$v.invoice_number.required && errors.push('Invoice number is required');
            return errors
        },
        invoiceComissionErrors () {
            const errors = [];
            if (!this.$v.comission.$dirty) {
                return errors;
            }
            !this.$v.comission.required && errors.push('Сommission is required');
            return errors
        },
    },

    methods: {
        submit () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                // create new time sheet
                this.localLoading = true;
                this.$store.dispatch('requestInvoice', {
                    invoice_number: this.invoice_number,
                    comission: this.comission,
                    period_date_from: this.periodDateFrom,
                    period_date_to: this.periodDateTo,
                    restaurant_id: this.restaurantId,
                    driver_id: this.driverId
                }).then(() => {
                    this.clear(); // reset form
                    this.dialog = false; // close dialog
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        preview () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                // create new time sheet
                this.localLoading = true;
                this.$store.dispatch('previewInvoice', {
                    invoice_number: this.invoice_number,
                    comission: this.comission,
                    period_date_from: this.periodDateFrom,
                    period_date_to: this.periodDateTo,
                    restaurant_id: this.restaurantId,
                    driver_id: this.driverId
                }).then(() => {
                    // this.clear(); // reset form
                    // this.dialog = false; // close dialog
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        clear () {
            this.$v.$reset();
            this.invoice_number = void 0;
            this.comission = 1.5;
        },
    },
}
</script>

<style scoped>

</style>
